import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import Searcher from './Searcher';
import DetailsHandlerDef from "../details/DetailsHandlerDef";
/**
 *
 * @class Searches gst geoservice (http://www.kortforsyningen.dk/dokumentation/geonoeglergeosearch)
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.S3earcher
 * @param {Object} options GeoSearch expects these properties:
 * @param options.area {string} "muncode" + municipalitycode eg.; "muncode0151"
 * @param options.authParams {Object} Either {ticket: 'ttttt'}, where t is a ticket issued by kortforsyningen or {login: 'lll', password: 'pppp'}
 *
 *
 */

export default Class(Searcher,
/**  @lends Septima.Search.S3earcher# */
{
  initialize: function initialize(options) {
    this.Searcher(options);
    if (options === undefined) throw "New Septima.Search.S3Searcher(options): Options missing.";
    this.indexedDatasources = null;
    this.s3Host = '';
    this.service = null;
    if (options.host) this.s3Host = options.host.replace(/\/$/, ""); //remove trailing slash

    if (options.service) this.service = options.service;else throw "New Septima.Search.S3earcher(options): Service missing.";
    this.endPoint = this.s3Host + this.service;
    this.sources = null;
    this.sourcesReady = this.getS3Sources();
  },
  getS3Sources: function () {
    var _getS3Sources = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, source, sourceName, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, type;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.sources === null)) {
                _context.next = 49;
                break;
              }

              this.sources = [];
              _context.next = 4;
              return fetch2(this.endPoint + '/sources', {});

            case 4:
              this.sources = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 8;
              _iterator = this.sources[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 35;
                break;
              }

              source = _step.value;
              sourceName = source.source;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 16;

              for (_iterator2 = source.types[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                type = _step2.value;
                this.registerType(sourceName, type);
              }

              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](16);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 24:
              _context.prev = 24;
              _context.prev = 25;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 27:
              _context.prev = 27;

              if (!_didIteratorError2) {
                _context.next = 30;
                break;
              }

              throw _iteratorError2;

            case 30:
              return _context.finish(27);

            case 31:
              return _context.finish(24);

            case 32:
              _iteratorNormalCompletion = true;
              _context.next = 10;
              break;

            case 35:
              _context.next = 41;
              break;

            case 37:
              _context.prev = 37;
              _context.t1 = _context["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 41:
              _context.prev = 41;
              _context.prev = 42;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 44:
              _context.prev = 44;

              if (!_didIteratorError) {
                _context.next = 47;
                break;
              }

              throw _iteratorError;

            case 47:
              return _context.finish(44);

            case 48:
              return _context.finish(41);

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[8, 37, 41, 49], [16, 20, 24, 32], [25,, 27, 31], [42,, 44, 48]]);
    }));

    function getS3Sources() {
      return _getS3Sources.apply(this, arguments);
    }

    return getS3Sources;
  }(),
  ready: function ready() {
    return this.sourcesReady;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query, caller) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.sourcesReady;

            case 3:
              this.myFetchData(query, caller);
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              caller.fetchError();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 6]]);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  myFetchData: function () {
    var _myFetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(query, caller) {
      var url, path, _path, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = query.type;
              _context3.next = _context3.t0 === 'collapse' ? 3 : _context3.t0 === 'cut' ? 7 : _context3.t0 === 'no-cut' ? 7 : _context3.t0 === 'list' ? 7 : 10;
              break;

            case 3:
              path = '';
              if (query.hasTarget) path = this.getPathFromTarget(query.target);
              url = this.endPoint + path + "?q=";
              return _context3.abrupt("break", 10);

            case 7:
              _path = '';
              if (query.hasTarget) _path = this.getPathFromTarget(query.target);
              url = this.endPoint + _path + "?q=" + query.queryString;

            case 10:
              _context3.prev = 10;
              _context3.next = 13;
              return fetch2(url);

            case 13:
              data = _context3.sent;
              data.query = query;
              this.success(caller, data);
              _context3.next = 21;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t1 = _context3["catch"](10);
              caller.fetchError();

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[10, 18]]);
    }));

    function myFetchData(_x3, _x4) {
      return _myFetchData.apply(this, arguments);
    }

    return myFetchData;
  }(),
  getPathFromTarget: function getPathFromTarget(target) {
    return "/sources/" + target.source + "/types/" + target.type;
  },
  getSourcesAsNewQueries: function getSourcesAsNewQueries() {
    var queryResult = this.createQueryResult();
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.sources[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var source = _step3.value;
        var sourceName = source.source;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = source.types[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var type = _step4.value;
            queryResult.addNewQuery(sourceName, type, type, null, "", null, null);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return queryResult;
  },
  success: function success(caller, data) {
    var queryResult = this.createQueryResult();
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var thisItem = _step5.value;

        if (thisItem.item === "newquery") {
          var newQuery = queryResult.addNewQuery(thisItem.source, thisItem.type, thisItem.title, thisItem.description, thisItem.newquery, null, null);
          newQuery.image = thisItem.image;
        } else if (thisItem.item === "shortresult") {
          var result = queryResult.addResult(thisItem.source, thisItem.type, thisItem.title, thisItem.description, null, thisItem);
          result.image = thisItem.image;
          result.id = thisItem.id;
          result.isComplete = false;
        } else if (thisItem.item === "deepresult") {
          var _result = queryResult.addResult(thisItem.source, thisItem.type, thisItem.title, thisItem.description, thisItem.geometry, thisItem);

          _result.image = thisItem.image;
          if (thisItem.id) _result.id = thisItem.id;
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    caller.fetchSuccess(queryResult);
  },
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(result) {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!result.isComplete) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", result);

            case 4:
              result.isComplete = true;
              _context4.next = 7;
              return fetch2(this.s3Host + result.data.href);

            case 7:
              data = _context4.sent;
              result.data = data;
              result.geometry = data.geometry;
              return _context4.abrupt("return", result);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function completeResult(_x5) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  hasdetailHandlerDefs: function hasdetailHandlerDefs(result) {
    if (result.data.details && result.data.details.length > 0) return true;else return false;
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(id, type, source) {
      var queryResult, url, data, thisItem, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryResult = this.createQueryResult();
              url = this.endPoint + "/sources/" + source + "/types/" + type + "/" + id;
              _context5.next = 4;
              return fetch2(url);

            case 4:
              data = _context5.sent;
              thisItem = data;

              if (!(thisItem.item === "result")) {
                _context5.next = 11;
                break;
              }

              result = queryResult.addResult(thisItem.source, thisItem.type, thisItem.title, thisItem.description, thisItem.geometry, thisItem);
              result.image = thisItem.image;
              if (thisItem.id) result.id = thisItem.id;
              return _context5.abrupt("return", result);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function get(_x6, _x7, _x8) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  getDetailHandlersForResult: function getDetailHandlersForResult(result) {
    var _this = this;

    var details = result.data.details;
    var detailHandlerDefs = [];

    if (typeof details !== 'undefined') {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        var _loop = function _loop() {
          var thisDetail = _step6.value;

          if (thisDetail.href) {
            var detailHandlerDef = new DetailsHandlerDef({
              "buttonText": thisDetail.title,
              "buttonImage": thisDetail.image,
              "handler": function () {
                var _handler = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee6() {
                  var queryResult, returnItems, detailItems, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, detailItem, _result2;

                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          queryResult = _this.createQueryResult();
                          returnItems = [];
                          _context6.next = 4;
                          return fetch2(_this.s3Host + thisDetail.href);

                        case 4:
                          detailItems = _context6.sent;
                          _iteratorNormalCompletion7 = true;
                          _didIteratorError7 = false;
                          _iteratorError7 = undefined;
                          _context6.prev = 8;

                          for (_iterator7 = detailItems[Symbol.iterator](); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            detailItem = _step7.value;

                            if (detailItem.type === 'result') {
                              _result2 = queryResult.addResult(detailItem.result.source, detailItem.result.type, detailItem.result.title, detailItem.result.description, null, detailItem.result);
                              _result2.isComplete = false;
                              _result2.image = detailItem.result.image;
                              _result2.id = detailItem.result.id;
                              _result2.distance = detailItem.result.distance;
                              detailItem.result = _result2;
                            }

                            returnItems.push(detailItem);
                          }

                          _context6.next = 16;
                          break;

                        case 12:
                          _context6.prev = 12;
                          _context6.t0 = _context6["catch"](8);
                          _didIteratorError7 = true;
                          _iteratorError7 = _context6.t0;

                        case 16:
                          _context6.prev = 16;
                          _context6.prev = 17;

                          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                            _iterator7.return();
                          }

                        case 19:
                          _context6.prev = 19;

                          if (!_didIteratorError7) {
                            _context6.next = 22;
                            break;
                          }

                          throw _iteratorError7;

                        case 22:
                          return _context6.finish(19);

                        case 23:
                          return _context6.finish(16);

                        case 24:
                          return _context6.abrupt("return", returnItems);

                        case 25:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, null, [[8, 12, 16, 24], [17,, 19, 23]]);
                }));

                function handler() {
                  return _handler.apply(this, arguments);
                }

                return handler;
              }(),
              "more": thisDetail.more
            });
            detailHandlerDefs.push(detailHandlerDef);
          }
        };

        for (var _iterator6 = details[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }

    return detailHandlerDefs;
  },
  CLASS_NAME: 'Septima.Search.S3Searcher'
});